import React from 'react';

/* ─── SECTOR AIR ──────────────────────────────────────────────────────────
   What is hanging in each sector's sky: crosses and pulses over the hospital,
   bolts over the grid, plates over the plant, books over the campus.

   Small, many, scattered, and drifting on their own lagging scrub. They are
   the reference's clouds and bats and stars — texture until you look at one,
   and then they tell you where you are. The sector's real identity is the
   place standing in the background (see SectorWorld and serviceVisuals);
   this only has to agree with it.
   ───────────────────────────────────────────────────────────────────────── */

/* Deterministic. These are re-rendered on every resize, and a field that
   reshuffles itself under the reader is worse than no variation at all. */
function rng(seed) {
  let s = seed >>> 0;
  return () => { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; };
}

function scatter(seed, n, draw) {
  const rnd = rng(seed);
  const out = [];
  for (let i = 0; i < n; i++) {
    const x = rnd() * 1400 - 200;
    const y = rnd() * 780 - 150;
    const s = 0.55 + rnd() * 0.9;
    out.push(
      <g key={i}
        transform={`translate(${x.toFixed(1)} ${y.toFixed(1)}) scale(${s.toFixed(2)})`}>
        {draw(i)}
      </g>
    );
  }
  return out;
}

const MOTES = {
  // 01 · Healthcare — crosses and pulses
  '01': () => scatter(4101, 30, i => (i % 3
    ? <path d="M -1.8 -6 h 3.6 v 4.2 h 4.2 v 3.6 h -4.2 v 4.2 h -3.6 v -4.2 h -4.2 v -3.6 h 4.2 Z" />
    : <circle r="2.2" />)),
  // 02 · Utilities & Energy — bolts
  '02': () => scatter(4202, 30, i => (i % 3
    ? <path d="M 2 -7 L -3.5 1 L 0 1 L -2 7 L 4 -1 L 0.5 -1 Z" />
    : <circle r="2" />)),
  // 03 · Industrial IoT — plates
  '03': () => scatter(4303, 30, i => (i % 3
    ? <rect x="-3.5" y="-3.5" width="7" height="7" rx="1.2" />
    : <circle r="2.2" />)),
  // 04 · Education — caps
  '04': () => scatter(4404, 30, i => (i % 3
    ? <path d="M 0 -5 L 8 -1.5 L 0 2 L -8 -1.5 Z M 0 2.6 L 5 0.4 L 5 4.4 L 0 6.4 Z" />
    : <circle r="2" />)),
};

export function SceneMotes({ id }) {
  const M = MOTES[id];
  return M ? <>{M()}</> : null;
}
